<div class="representante-card">
  <!-- Logo -->
  <div class="logo">
    <p-avatar
      *ngIf="!imageError && (representante?.foto?.objectURL || foto); else defaultAvatar"
      [image]="$any(representante?.foto?.objectURL || foto)"
      shape="circle"
      size="large"
      (onImageError)="imageError = true"
    />
    <ng-template #defaultAvatar>
      <p-avatar
        [label]="getInitials(representante?.nome)"
        [icon]="!representante?.nome ? 'pi pi-user' : undefined"
        shape="circle"
        size="large"
      />
    </ng-template>
  </div>

  <div class="details">
    <h3 class="name">{{ representante?.nome | uppercase }}</h3>
    <p class="description">{{ instituicaoEnsino?.nome | uppercase }} <b>{{ instituicaoEnsino?.sigla | uppercase }}</b>
    </p>
  </div>

  <!-- Contact Details -->
  <div class="contact-info">
    <div class="country">
      <div class="icon">
        <img src="icons/globe.svg" alt="Country Icon" />
      </div>
      <span>{{ representante?.usernameRepresentante | uppercase }}</span>
    </div>
    <div class="phone">
      <div class="icon">
        <img src="icons/phone.svg" alt="Phone Icon" />
      </div>
      <span>{{ representante?.telefone }}</span>
    </div>

    <div class="email">
      <div class="icon">
        <img src="icons/email.svg" alt="Email Icon" />
      </div>
      <span>{{ representante?.emailRepresentante }}</span>
    </div>
  </div>

  <!-- Navigation Icon -->
  <div class="navigate" (click)="ShowDetais($event)">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    </svg>
  </div>

  <div class="details-card" *ngIf="Show">
    <button type="button" (click)="Editar($event)"><i class="pi pi-pen-to-square"></i> Editar</button>
    <button type="button" (click)="RedefinirSenha($event)"><i class="pi pi-key"></i> Redefinir Senha</button>
    <button type="button" (click)="deleteEvent($event)"><i class="pi pi-trash"></i> Eliminar</button>
    <!-- <button type="button" (click)="Notificar($event)"><i class="pi pi-bell"></i> Notificar</button> -->
  </div>
</div>